export default __webpack_public_path__ + "static/media/Exterior.2749805e.JPG";